<template>
  <wc-dialog
    :showDialog='showDialog'
    title='New Expense'
    :icon='$store.state.icons.dataBox.expenses.icon'
    iconColor='success'
    :loadingButtons='isSavingNewExpense'
    :disableButtons='!isFormValid'
    @cancel="$emit('cancel')"
    @save='generateExpense'
    saveText='Create Expense'
    width='350'
  >
    <v-form v-model='isFormValid' ref='form'>
      <wc-datepicker
        label='Expense date'
        required
        v-model='newExpense.expense_date'
        :min='this.$store.state.misc.accounting_settings.closed_fiscal_date'
      ></wc-datepicker>
      
      <v-text-field
        label='Store'
        :rules='[rules.required]'
        v-model='newExpense.purchased_at'
      ></v-text-field>

      <v-select
        label='Purchased By'
        v-model='newExpense.purchased_by'
        :items='staff'
        item-value='id'
        item-text='name_display'
      ></v-select>

      <v-select
        label='Paid by'
        v-model='newExpense.payment_account'
        :items='payment_accounts'
        :rules='[rules.required]'
        item-value='id'
        item-text='name'
      ></v-select>
    </v-form>
  </wc-dialog>
</template>

<script>
import accountingAPI from '@/api/accounting';
import staffingAPI from '@/modules/staffing/api/staffing';
import formRules from '@/mixins/formRules';

export default {
  name: 'new-expense-dialog',
  mixins: [formRules],
  props: {
    showDialog: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: true,
    isFormValid: false,
    isSavingNewExpense: false,
    newExpense: {},
    staff: [],
    payment_accounts: []
  }),
  computed: {
    clientArr () {
      if (this.billTo) {
        let tmp = []
        tmp.push(this.billTo)
        return tmp
      }
      return this.clients
    },
    divisionCategories () {
      return this.categories.filter(c => c.division === this.newExpense.division)
    },
    categories () {
      return this.$store.state.misc.woTypes.filter(t => t.archived === false)
    }
  },
  watch: {
    async showDialog () {
      this.staff = await staffingAPI.getProfiles()
      this.payment_accounts = await accountingAPI.getPaymentAccounts()
      this.resetExpense()
      if (this.showDialog === true) {
        this.$nextTick(() => {
          this.$refs.form.resetValidation()
        })
      }
    }
  },
  methods: {
    resetExpense () {
      this.newExpense = {
        created_by: this.$store.state.auth.profile.id,
        purchased_by: null,
        expense_date: null,
        payment_method: 'V'
      }
    },
    async generateExpense () {
      console.log(this.newExpense)
      let exp = await accountingAPI.createExpense(this.newExpense)
      this.$router.push({ name: 'ExpenseOverview', params: { id: exp.id } })
    }
  }
}
</script>
